import React from "react";
import Header from "../components/Header";
import Home from "../components/Home";
import About from "../components/About";
import Services from "../components/Services";
import Counters from "../components/Counters";
import Contact from "../components/Contact";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

// ! استيراد مكون الأنيميشن وملف الـ CSS الخاص به
import AnimateOnScroll from "../components/AnimateOnScroll";
import '../assets/css/animations.css';

function HomePage() {
  return (
    <>
      <Header />

      {/* لا نطبق الأنيميشن على القسم الأول لأنه يظهر مباشرة */}
      <Home /> 
      
      {/* نغلف كل قسم تالٍ بمكون الأنيميشن */}
      <AnimateOnScroll>
        <About />
      </AnimateOnScroll>
      
      <AnimateOnScroll>
        <Services />
      </AnimateOnScroll>

      <AnimateOnScroll>
        <Counters />
      </AnimateOnScroll>

      <AnimateOnScroll>
        <Contact />
      </AnimateOnScroll>
      
      <AnimateOnScroll>
        <FAQ />
      </AnimateOnScroll>

      <WhatsAppButton/>
      <Footer />
    </>
  );
}

export default HomePage;